export const constants = {
  CLIENT_ERROR_CODE: "#0001",
  SERVER_ERROR_CODE: "#0000",
  CLASSIFICATION_TYPE_ENABLE_CLASS_MODEL: 2,
  TYPE_PREFIX: "type",
  CLASSIFICATION_TYPE_NUMBER_OF_PROTECTED: 18,
  LIFE_CYCLE_STATE_TYPE_PROTECTED_INITIAL: 1,
  MESSAGE_LOG_TYPE_PROTECTED_INITIAL: 1,
  CLASSIFICATION_TYPE_ID: "classificationTypeId",
  CLASSIFICATION_PARENT_ID: "classificationParentId",
  MODEL_PARENT_ID: "modelParentId",
  PARTY_ROLE_TYPE_PARENT_ID: "parentPartyRoleTypeIdSpec",
  DEFAULT_MESSAGE_ID: 1,
  DATE_FORMAT: "YYYY-MM-DD",
  FETCH_EXCEPTION_MESSAGE: "Failed to fetch",

  /*Operation constants*/
  OPERATION_CREATE: "create",
  OPERATION_PATCH: "patch",
  OPERATION_READ: "read",
  OPERATION_DELETE: "delete",
  OPERATION_CHANGE_LIFECYCLE: "change_lifecycle",
  OPERATION_SECURITY_ADMINISTRATION: "security_administration",
  OPERATION_ENTITY_ADMINISTRATION: "entity_administration",
  OPERATION_KNOWLEDGE_ADMINISTRATION: "knowledge_administration",
  /*Operation constants - END*/

  RESOURCE_CLASSIFICATION: "classification",

  MENU_ITEM_TYPE_REACTIVATE: "reactivate",
  MENU_ITEM_TYPE_DELETE: "delete",
  KNOWLEDGE_ENTITY_TYPE: "hr.infodom.c2s2.entity.KnowledgeEntity"
};
